const HomeFooter = () => {
  return (
    <footer className="py-16 px-6 bg-gradient-to-br from-gray-900 via-black to-gray-800 dark:from-gray-100 dark:via-white dark:to-gray-200">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-gray-400 dark:via-gray-600 to-transparent mx-auto mb-8" />
          <p className="text-xs font-light tracking-[0.4em] uppercase text-gray-400 dark:text-gray-500 mb-4">Atelier StylistGPT</p>
          <p className="text-sm font-light text-gray-300 dark:text-gray-600 tracking-wide">Where artificial intelligence meets personal expression</p>
        </div>

        <div className="flex justify-center space-x-12 mb-12">
          <a href="#" className="text-gray-400 dark:text-gray-600 hover:text-white dark:hover:text-gray-900 transition-colors duration-300 text-sm font-light tracking-wide">Instagram</a>
          <a href="#" className="text-gray-400 dark:text-gray-600 hover:text-white dark:hover:text-gray-900 transition-colors duration-300 text-sm font-light tracking-wide">TikTok</a>
          <a href="#" className="text-gray-400 dark:text-gray-600 hover:text-white dark:hover:text-gray-900 transition-colors duration-300 text-sm font-light tracking-wide">Contact</a>
        </div>

        <div className="text-center border-t border-gray-700 dark:border-gray-300 pt-8">
          <p className="text-xs font-light text-gray-500 dark:text-gray-400 tracking-wider">© 2025 StylistGPT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
